import { useMemo, useState } from 'react';
import { fetchSearchResults } from '../../../api/searchBarAPI';
import { OptionType } from '../../../utils/types';
import { SearchBarResult } from './types';

export const useSearchBar = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [results, setResults] = useState<SearchBarResult | null>(null);
    const [error, setError] = useState(null);

    const generateOptions = useMemo(() => {
        const userOptions: OptionType[] = [];
        const eventOptions: OptionType[] = [];
        results?.users?.forEach(user => {
            userOptions.push({
                id: user.id,
                label: user.username,
                image: user.avatarUrl,
                averageRating: user.averageRating,
            });
        });
        results?.events?.forEach(eventRecord => {
            eventOptions.push({
                id: eventRecord.id,
                label: eventRecord.name,
                image: eventRecord.owner.avatarUrl,
                averageRating: eventRecord.owner.averageRating,
            });
        });
        return { users: userOptions, events: eventOptions };
    }, [results]);

    const fetchResults = async (searchString: string) => {
        try {
            setIsLoading(true);
            const data = await fetchSearchResults(searchString);
            setResults(data);
        } catch (error: any) {
            console.warn(error);
            setError(error);
        }
        setIsLoading(false);
    };

    return { isLoading, searchOptions: generateOptions, error, fetchResults };
};
